import { useCallback, useEffect, useState } from "react"
import type { CombinedError } from "urql"
import { useQuery } from "urql"

import type { Contact, ContactListSuccess, Query } from "@/graphql/codegen/graphql"
import { ContactListDocument } from "@/graphql/codegen/graphql"

const LIMIT = 100

export const useGetContacts = (
  companyId: string,
  options?: { pause?: boolean }
): {
  contactListError: CombinedError | undefined
  contactList: Contact[]
  contactListFetching: boolean
  triggerQuery: () => void
} => {
  const [contactList, setContactList] = useState<Contact[]>([])

  const [
    { data: contactDetails, fetching: contactDetailsFetching, error: contactDetailsError },
    queryContactByCompanyId,
  ] = useQuery<Pick<Query, "contact">>({
    query: ContactListDocument,
    variables: { input: { filter: { companyIds: [companyId] }, limit: LIMIT, offset: 0 } },
    pause: options?.pause,
  })

  useEffect(() => {
    if (contactDetails) {
      const locations = (contactDetails.contact?.list as ContactListSuccess).contacts
      setContactList(locations)
    }
  }, [contactDetails])

  const triggerQuery = useCallback(
    () => queryContactByCompanyId({ companyId, requestPolicy: "network-only" }),
    [companyId, queryContactByCompanyId]
  )

  return {
    contactList,
    contactListFetching: contactDetailsFetching,
    contactListError: contactDetailsError,
    triggerQuery,
  }
}
